import type { GraphQLError } from 'graphql';

const isGraphQLError = (arg: any): arg is GraphQLError =>
  arg !== undefined && arg.hasOwnProperty('message');

export const isReadonlyArrayGraphQLError = (
  arg: any
): arg is ReadonlyArray<GraphQLError> =>
  Array.isArray(arg) && isGraphQLError(arg[0]);
